import React from 'react';
import { Field, Form } from 'formik';
import FormikInputField from 'components/Fields/FormikInputField';
import { Button, Col, Row } from 'reactstrap';
import CardWithTitle from 'components/CardWithTitle';
import S3FileUploadField from 'components/S3FileUploadField';
import EditUploadWrapper from 'components/EditUploadWrapper';
import { dynamicButtonHeading } from 'utils/constants';
import LoadingButton from 'components/common/LoadingButton';
import CategorySelectField from 'components/CategorySelectField';

const AddEditProductForm = (props) => {
  const {
    handleSubmit,
    isSubmitting,
    isValid,
    dirty,
    toggleAddRecord,
    type,
    values,
    setFieldValue,
  } = props;
  const handleCancel = (val) => {
    setFieldValue(val, '');
  };

  return (
    <Form onSubmit={handleSubmit}>
      <CardWithTitle title="">
        <Row>
          <Col sm={5}>
            <CategorySelectField required />
          </Col>
          <Col sm={5}>
            <Field
              label="Product Name"
              name="name"
              type="text"
              component={FormikInputField}
              required
            />
          </Col>
        </Row>
      </CardWithTitle>
      <CardWithTitle title="">
        {values.photo ? (
          <EditUploadWrapper
            label="Product Image"
            fileName={values.photo}
            name="photo"
            // uploadDate="Uploaded on 23dec,2022"
            handleCancel={() => handleCancel('photo')}
            accept=".png, .jpg, .jpeg, .pdf"
          />
        ) : (
          <S3FileUploadField
            label="Product Image"
            name="photo"
            pathUrl="images/products/photos"
            accept=".png, .jpg, .jpeg, .pdf"
            containerName="public-assets"
          />
        )}
      </CardWithTitle>
      <CardWithTitle title="">
        {values.document ? (
          <EditUploadWrapper
            label="Document"
            name="document"
            fileName={values.document}
            // uploadDate="Uploaded on 23dec,2022"
            handleCancel={() => handleCancel('document')}
            accept=".png, .jpg, .jpeg, .pdf"
          />
        ) : (
          <S3FileUploadField
            label="Document"
            name="document"
            pathUrl="images/products/documents"
            accept=".png, .jpg, .jpeg, .pdf"
            containerName="public-assets"
          />
        )}
      </CardWithTitle>
      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          onClick={toggleAddRecord}
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
        >
          Cancel
        </Button>
        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting}
          disabled={!isValid || !dirty || isSubmitting}
          color="warning"
          size="sm"
          type="submit"
        >
          {dynamicButtonHeading(type)}
        </LoadingButton>
      </div>
    </Form>
  );
};

export default AddEditProductForm;
